import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import { Fragment, type ReactElement } from "react";
import { MdKey, MdStorage } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactElement {
  const { deploymentId } = useParams();
  return (
    <Layout
      {...props}
      deploymentElements={
        deploymentId && (
          <Fragment>
            <NavListSectionHeader>Deployment CD-{deploymentId}</NavListSectionHeader>
            <NavLink to={`/account/deployment/${deploymentId}/credentials`}>
              <NavListItem icon={MdKey}>Manage Credentials</NavListItem>
            </NavLink>
            <NavLink to={`/account/deployment/${deploymentId}/usage`}>
              <NavListItem icon={MdStorage}>API Usage</NavListItem>
            </NavLink>
          </Fragment>
        )
      }
    />
  );
}
